import styled from 'styled-components';

import vars from 'variables';

import check from 'assets/Common/InfoBox/check.svg';
import info from 'assets/Common/InfoBox/info.svg';

const Root = styled.div`
  margin-bottom: 11px;
  position: relative;
  background: rgb(1, 10, 32);
  background-clip: padding-box;
  border: 1px solid transparent;
  border-radius: 5px;

  &:before {
    content: "";
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: -2px;
    position: absolute;
    border-radius: inherit;
    background: rgb(36,41,107);
    background: linear-gradient(200deg, rgb(0, 149, 213) 20%, rgb(37, 95, 157) 70%);
    z-index: -1;
  }

  &.done {
    background-image: url(${check});
    background-repeat: no-repeat;
  }

  &.done:before {
    background: linear-gradient(200deg, rgb(116, 248, 131) 20%, rgb(34, 83, 64) 70%);
  }

  a, span {
    padding: 12px 37px 12px 15px;
    display: block;
    font-weight: bold;
    font-size: 0.8rem;
    line-height: 135%;
    text-transform: uppercase;
    background: url(${info}) no-repeat right 10px center;
  }

  a[data-tip],
  span[toggler] {
    cursor: pointer;
  }

  .info {
    display: none;
  }

  .tooltip {
    max-width: 365px;
    padding: 16px 12px 12px 18px;
    line-height: 175%;
    background-color: ${vars.colors.marineBlue};
    border-radius: 10px;
    opacity: 1 !important;
    &.place-top {
      &:after {
        border-top-color: ${vars.colors.marineBlue};
      }
    }
    &.place-right {
      &:after {
        border-right-color: ${vars.colors.marineBlue};
      }
    }
    &.place-bottom {
      &:after {
        border-bottom-color: ${vars.colors.marineBlue};
      }
    }
    &.place-left {
      &:after {
        border-left-color: ${vars.colors.marineBlue};
      }
    }
  }

  ${vars.desktop.mediaQuery} {
    &.done {
      background-position: left 10px center;
    }

    &.done a,
    &.done span {
      padding-left: 35px;
    }
  }

  ${vars.mobile.mediaQuery} {
    & {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }

    &.done {
      background-position: top 15px left 13px;
      background-size: 15px;
    }

    span {
      padding: 17px 37px 16px 15px;
      font-size: 0.65rem;
      background-size: 15px;
    }

    &.done span {
      padding-left: 34px;
    }

    .info {
      margin-top: -5px;
      color: ${vars.colors.grey};
      padding-right: 16px;
      padding-bottom: 14px;
      padding-left: 16px;
    }

    .info.open {
      display: block;
    }
  }
`;

export { Root };
